"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addToRange = void 0;
var date_fns_1 = require("date-fns");
/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */
function addToRange(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (!from) {
        return { from: day, to: day };
    }
    if (!to && date_fns_1.isSameDay(from, day)) {
        return undefined;
    }
    if (!to && date_fns_1.isBefore(day, from)) {
        return { from: day, to: from };
    }
    if (!to) {
        return { from: from, to: day };
    }
    if (date_fns_1.isSameDay(to, day) && date_fns_1.isSameDay(from, day)) {
        return undefined;
    }
    if (date_fns_1.isSameDay(to, day)) {
        return { from: to, to: to };
    }
    if (date_fns_1.isSameDay(from, day)) {
        return undefined;
    }
    if (date_fns_1.isAfter(from, day)) {
        return { from: day, to: to };
    }
    return { from: from, to: day };
}
exports.addToRange = addToRange;
//# sourceMappingURL=addToRange.js.map